module.exports = __webpack_public_path__ + "img/20171229_174817.6810d59c.jpg";